import { CalendarIcon, TimeIcon } from "./IconsSvg";
import { DateDiv } from "styles/jss/Home.styles";
import { formatDate, formatTime } from "utils/helperFunction";
import { useEffect, useState } from "react";
import { useRouter } from "next/router";

export default function DateStamp(props) {
  const { locale } = useRouter();
  const [date, setDate] = useState(null);

  useEffect(() => {
    setDate(props.date);
  }, [props]);

  return (
    <DateDiv>
      {!!date && (
        <div className="date">
          <i>
            <CalendarIcon />
          </i>
          <span>
            {formatDate(
              date,
              locale === "fa" ? "jDD jMMMM, jYYYY" : "MMMM DD, YYYY",
              locale,
            )}
          </span>
        </div>
      )}
      {!!props.time && (
        <div className="date">
          <i>
            <TimeIcon />
          </i>
          {!!date && <span>{formatTime(date, locale)}</span>}
        </div>
      )}
    </DateDiv>
  );
}
